let config = undefined;

let innerHandle = (resolve, reject) =>
{
  if (config != undefined)
  {
    resolve(config);
  }
  else
  {
    setTimeout(() => { innerHandle(resolve, reject) }, 500);
  }
};

let setConfig = (newConfig) =>
{
  config = newConfig;
}

let getConfig = () =>
{
  let promise = new Promise((resolve, reject) =>
  {
    innerHandle(resolve, reject);
  });

  return promise;
}

let loadConfig = () =>
{
  return fetch('/config.json').then(async (response) =>
  {
    if (response.ok)
    {
      let tempEnv = await response.json();
      let $env = {
        ...process.env,
        ...tempEnv
      };
      console.log("Environment is as follows:", $env, tempEnv);
      setConfig($env);
    }
  });
}

export
{
  setConfig,
  getConfig,
  loadConfig,
}